// import '../plugins/email-field'

/* global mlmi_locator_localization */
let popupTimeout = undefined

export default {
  init() {
    if ($('body').hasClass('home')) {
      /* Detect active popup */
      let $active = undefined
      let delay = 0
      $('.home-popup').each(function() {
        if ($active === undefined) {
          let $element = $(this)
          delay = parseInt($element.data('delay'), 10) | 0
          const now = Math.floor((new Date()).getTime() / 1000)
          const start = parseInt($element.data('start'), 10)
          const end = parseInt($element.data('end'), 10) | 0
          if (now >= start && (!end || now < end)) {
            $active = $element
          }
        }
      })

      /* Display active popup */
      if ($active !== undefined) {
        /* Initialize email field */
        // $active.find('.email-field').each(function() {
        //   $(this).EmailField()
        // })

        /* Open popup */
        clearTimeout(popupTimeout)
        popupTimeout = setTimeout(function() {
          $.fancybox.open({
            src: $active,
            type: 'inline',
            touch: false,
            lang: mlmi_locator_localization.language,
            i18n: {
              fr: {
                CLOSE: 'Fermer',
                ERROR: 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
              },
            },
          })
        }, delay * 1000)
      }
    }
  },

  kill() {
    clearTimeout(popupTimeout)
    $('.home-popup').remove()
  },
}
